<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Toastmaster Club </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<ul class="breadcrumb">
    <li><a href="#">Event</a></li>
    <li><i class="fa fa-angle-double-right"></i></li>
    <li>Toastmaster Club </li>
</ul>

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="text-justify" >
                    <p>Raisoni Toastmasters provides a supportive and positive learning experience in
                        which students are empowered to develop communication and leadership skills
                        resulting in greater self confidence and personal growth</p>
                    <p>Public speaking and leadership skills are the two sides of the same coin named
                        TOASTMASTERS .</p>
                    <p>Public speaking can make your heart skip a beat and ‘I am going to die on stage
                        fear grips you'. But the speech assignments in Toastmasters helps you to
                        research on the topic, it teaches you to get to the point ,organize your
                        speeches and it also guides you how to present your speech, how to persuade and
                        inspire your audience.Toastmasters is a perfect platform to grow as a speaker as
                        well as an individual who can accept challenges and to overcome them with
                        triumph.</p>
                    <p>It was rightly stated by Ralph Smedly the founder of TOASTMASTERS “But just what do
                        we mean by ‘leadership’it would appear to be the capacity to look ahead ,think ahead
                        ,plan ahead ,and then influence other people to go ahead on the plan”. In leadership
                        skills one can learn to inspire ,coach,support and delegate others.</p>

                </div>
            </div>
            <div class="col-md-4">
                <iframe src="https://drive.google.com/file/d/1hP9LCB88GR2DE7Xn0d92iPmyKR1QD1ey/preview?" width="100%"
                    height="450px" frameborder="0"></iframe>
            </div>
            <div class="col-md-12">
                <p>Being a part of toastmasters ,an individual displays improved communication skills
                    and interpersonal relations. His personal growth is judged and appreciated by people
                    around who do notice the changed personality ,but this change can be achieved only
                    by achieving ones own personal goals along with the enhanced performance in the show
                    of leadership skills.</p>
                <p>Weekly meetings ,Monthly contest [Inspirational,humorous,table topics,spin a
                    yarn,evaluation],Toastfest [a three day event],Youth Leadership Programmes in
                    different schools,Mega event of youth leader ship programmes,TM Achievers
                    day,Hyderabad visits for various contest,Area governers and distinguished
                    toastmasters coming to interact and guide the students in their Toastmasters journey
                </p>
                <p>We at Raisoni Toastmaster club have been very open in a variety of ways ,different
                    view points,innovative approaches that makes the club atmosphere fresh and
                    vibrant.New students enrolling every year are fascinated by this world of Raisoni
                    Toastmasters .Sheer determination and hardwork has made us climb the ladder of
                    success . We have climbed each rung of the ladder with caution and a never say die
                    attitude which has helped us to achieve the coveted PRESIDENTIAL DISTINGUISHED
                    2015-16. Stepping up from being SELECT DISTINGUISHED 2014-15,it really made us proud
                    to become President Distinguished .PHOENIX award,GOLDEN EAGLE award for the best
                    club at Hyderabad 2015-16 are a few more jewels added to our crown .CC’s ,CL’s and
                    AC[BRONZE] accomplished by our students made us realize Raisoni Toastmasters is
                    shinning ..3 of our students made history in Raisoni Toastmaster Club by completing
                    ADVANCED COMMUNICATION BRONZE .Students participation in the clubs YLP to train
                    young minds to become better orators of the future,has made us at Raisoni feel proud
                    all the more . The newly introduced pathway also has the students actively
                    introduced to it and nearly 10 of them are in level 4 already .</p>
                <p>We at Raisoni are basking in the warmth of our new found glory and hope our club
                    keeps rising and rising beyond one’s imagination.</p>
                <p>We are here not to conquer the world but to set the adrenaline rushing of one and all
                    through platform of “Toastmasters”.</p>
            </div>
        </div>
        <div class="row mb-20 mt-5">
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-7.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-8.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-8.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>



            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-1.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-2.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-3.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-4.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-5.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-6 col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/gallery/toast-6.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/gallery/toast-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay">
                            <h6>Toastmaster</h6>
                        </div>
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>